import Page from "@/components/layout/Page";

export default function LocalAuthorities() {
  return (
    <div className="min-h-screen overflow-hidden bg-gradient-to-b from-[#020817] via-[#04151F] to-[#020817] text-slate-50">
      <Page>
        <section className="w-full pb-24">
          <div className="max-w-[1280px] mx-auto px-6">
          <h1 className="text-[54px] leading-[1.1] font-bold mb-6 page-title-gradient">Local Authorities</h1>
          
          <div className="space-y-6 max-w-3xl">
            <p className="text-xl text-muted-foreground leading-relaxed">
              Supporting community programs with sensory resources for diverse populations.
            </p>
            
            <p className="text-lg leading-relaxed">
              Samboards partners with local authorities across the UK to provide sensory support solutions for community services, social care provisions, and educational settings. Our products support councils in delivering inclusive services for residents with additional needs.
            </p>
            
            <p className="text-lg leading-relaxed">
              Local authority SEND teams, youth services, libraries, and community centres use our sensory products to create accessible spaces where everyone can feel comfortable and engaged. From sensory rooms in public buildings to toolkits for social workers, we provide practical solutions for public sector needs.
            </p>
            
            <p className="text-lg leading-relaxed">
              We understand public sector procurement requirements and can work with local authorities to provide bulk orders, framework agreements, and value-for-money solutions that meet your budgetary and service delivery needs.
            </p>
            
            <p className="text-lg leading-relaxed">
              Our products support local authorities in meeting their duties under the Equality Act and SEND Code of Practice, helping create truly inclusive community services for all residents.
            </p>
          </div>
        </div>
      </section>
      </Page>
    </div>
  );
}
